import { SpinnerIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { FC, HTMLProps } from 'react'

interface Props extends HTMLProps<HTMLImageElement> {
  isLoading?: boolean
}

const Thumbnail: FC<Props> = ({
  src,
  isLoading = false,
  className = '',
  alt = '',
}) => {
  if (isLoading) {
    return (
      <div className="flex h-full w-full flex-col items-center text-center">
        <SpinnerIcon className="my-auto size-8 animate-spin text-gray-200" />
      </div>
    )
  }

  return (
    <div className="relative flex size-full overflow-hidden">
      <picture>
        <source srcSet={src} />
        <img
          loading="lazy"
          alt={alt}
          src={src.replace('.webp', '.png')}
          className={classNames(
            'absolute left-0 top-0 h-full w-full object-contain',
            className,
          )}
        />
      </picture>
    </div>
  )
}

export default Thumbnail
